import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomActivosFijosBasicosLogisticos
 * @author: Juan Camilo Villa Osorio
 * @version: jdesk_1.01.0002
 **/
class CustomActivosFijosBasicosLogisticos extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.arrayObjetos = new Map();
        this.arrayCampos = new Map();
        this.crearRegistro = this.crearRegistro.bind(this);
        this.successCrear = this.successCrear.bind(this);
        this.actualiarRegistro = this.actualiarRegistro.bind(this);
        this.successActualizar = this.successActualizar.bind(this);

        this.traerPrimero = this.traerPrimero.bind(this);
        this.successtraerPrimero = this.successtraerPrimero.bind(this);
        this.traerPorId = this.traerPorId.bind(this);
        this.successtraerPorId = this.successtraerPorId.bind(this);
        this.validarRegistroEliminar = this.validarRegistroEliminar.bind(this);
        this.succesvalidarRegistroEliminar = this.succesvalidarRegistroEliminar.bind(this);
        this.eliminarPorId = this.eliminarPorId.bind(this);
        this.successeliminarPorId = this.successeliminarPorId.bind(this);
        this.btnModificar = false;
        this.onClickChange = this.handlerClickChange.bind(this);
        this.onClickShowTable = this.handerClickShowTable.bind(this);
        this.onClickNew = this.handlerClickNew.bind(this);
        this.onClickDelete = this.handlerClickDelete.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.registro_seleccionado = false;
        this.mostrarMensajeSeleccionModificar = this.mostrarMensajeSeleccionModificar.bind(this);
        this.mostrarMensajeSeleccionEliminar = this.mostrarMensajeSeleccionEliminar.bind(this);
        this.successValidarUniqueRegistro = this.successValidarUniqueRegistro.bind(this);
        this.traerTodos = this.traerTodos.bind(this);
        this.successtraerTodos = this.successtraerTodos.bind(this);
        this.confirmarEliminacionRegistro = this.confirmarEliminacionRegistro.bind(this);
        this.abrirImprimir = this.abrirImprimir.bind(this);
        this.btnCancelarRegistroModificar = this.btnCancelarRegistroModificar.bind(this);


        //imprimir
        this.isJson                         =this.isJson.bind(this);
        this.generarExcelTabla3                         =this.generarExcelTabla3.bind(this);
        this.generarPdfTabla3                         =this.generarPdfTabla3.bind(this);
        this.mostrarMensajeNoHayDatos                         =this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);
        this.successEnviarCorreo                         =this.successEnviarCorreo.bind(this);
        this.enviarCorreoTerceros                         =this.enviarCorreoTerceros.bind(this);
        this.procesar                         =this.procesar.bind(this);
        this.mostrarMensajeAdicional                         =this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando                         =this.mostrarMensajeGenerando.bind(this);
        this.setButtonTableActivosFijosBasicos = this.setButtonTableActivosFijosBasicos.bind(this);
        this.crearBotonTabla = this.crearBotonTabla.bind(this);
        this.modificarImagenArchivo = this.modificarImagenArchivo.bind(this);
        this.objectSendArchiveImage = this.objectSendArchiveImage.bind(this);
        this.obtenerImagen = this.obtenerImagen.bind(this);
        this.successSubirTXT = this.successSubirTXT.bind(this);
        this.objectSendImage = this.objectSendImage.bind(this);
        this.successSubirImagen = this.successSubirImagen.bind(this);

        this.eliminarModificarImagenBasicos = this.eliminarModificarImagenBasicos.bind(this);
        this.successEliminarModificarImagenBasicos = this.successEliminarModificarImagenBasicos.bind(this);




        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.llenar = this.llenar.bind(this);
        this.traer_por_id = true;
        this.operacion_actual = '';
        this.nombre_archivo = 'listado_activos_fijos_basicos_logisticos';
        this.sucursal_ingreso ='';
        localStorage.setItem('deleteCancelar', 'false');
        this.arrayArchive = [];
        this.arrayImages = [];
        this.arrayImagesArchiveEliminar = [];
        this.arrayImagesArchiveActualizar = [];
        this.mensajeError = '';

        this.allowedExtensions = /(.txt|.TXT|.pdf|.PDF)$/i;
        this.allowedImagesExtensions = /(.jpg|.jpeg|.png|.JPG|.JPEG|.PNG)$/i;
        this.archivoTXT = "";
        this.archivoImagen = "";
        this.archivoImagen2 = "";
        this.archivoImagen3 = "";
        this.archivoImagen4 = "";
        this.archivoImagen5 = "";
        this.archivoModificar = "";
        this.imagenModificar = "";
        this.imagenModificar2 = "";
        this.imagenModificar3 = "";
        this.imagenModificar4 = "";
        this.imagenModificar5 = "";
        this.contador = 0;
        this.id = 0;

    }

    initForm() {
        console.log('Formulario CustomActivosFijosBasicosLogisticos,  @version: jdesk_1.01.0004, @author: Juan Camilo Villa Osorio');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.arrayCampos.set(1, 'activos_fijos_basicos_logisticos_id');
        this.arrayCampos.set(2, 'codigo');
        this.arrayCampos.set(3, 'serialactivo');
        this.arrayCampos.set(4, 'nombre');
        this.arrayCampos.set(5, 'fechacreacion');
        this.arrayCampos.set(6, 'estadoactivo_id');
        this.arrayCampos.set(7, 'bodega_id');
        this.arrayCampos.set(8, 'empresa_id');
        this.arrayCampos.set(9, 'grupos_id');
        this.arrayCampos.set(10, 'responsable_id');
        this.arrayCampos.set(11, 'series_id');
        this.arrayCampos.set(12, 'label_form');
        this.arrayCampos.set(13, 'archivos');
        this.arrayCampos.set(14, 'imagenes');
        this.arrayCampos.set(15, 'codigo_grupo');
        this.arrayCampos.set(16, 'nombre_grupo');
        this.arrayCampos.set(17, 'codigo_serie');
        this.arrayCampos.set(18, 'nombre_serie');
        this.arrayCampos.set(19, 'codigo_bodega');
        this.arrayCampos.set(20, 'btn_imprimir');
        this.arrayCampos.set(21, 'nombre_bodega');

/*         this.arrayCampos.set(22, 'archivos2');
        this.arrayCampos.set(23, 'archivos3');
        this.arrayCampos.set(24, 'archivos4');
        this.arrayCampos.set(25, 'archivos5'); */

        this.arrayCampos.set(26, 'imagenes2');
        this.arrayCampos.set(27, 'imagenes3');
        this.arrayCampos.set(28, 'imagenes4');
        this.arrayCampos.set(29, 'imagenes5');

        this.arrayCampos.set(30, 'btn_agregar');
        this.arrayCampos.set(31, 'btn_cancelar');
        this.arrayCampos.set(32, 'btn_modificar');
        this.arrayCampos.set(33, 'btn_cancelar_modificar');
        //this.arrayCampos.set(34,'operacion');
        this.arrayObjetos.set(1, 'activos_fijos_basicos_logisticos_id');
        this.arrayObjetos.set(2, 'codigo');
        this.arrayObjetos.set(3, 'serialactivo');
        this.arrayObjetos.set(4, 'nombre');
        this.arrayObjetos.set(5, 'fechacreacion');
        this.arrayObjetos.set(6, 'estadoactivo_id');
        this.arrayObjetos.set(7, 'bodega_id');
        this.arrayObjetos.set(8, 'empresa_id');
        this.arrayObjetos.set(9, 'grupos_id');
        this.arrayObjetos.set(10, 'responsable_id');
        this.arrayObjetos.set(11, 'series_id');
        this.arrayObjetos.set(12, 'label_form');
        this.arrayObjetos.set(13, 'archivos');
        this.arrayObjetos.set(14, 'imagenes');
        this.arrayObjetos.set(15, 'codigo_grupo');
        this.arrayObjetos.set(16, 'nombre_grupo');
        this.arrayObjetos.set(17, 'codigo_serie');
        this.arrayObjetos.set(18, 'nombre_serie');
        this.arrayObjetos.set(19, 'codigo_bodega');
        this.arrayObjetos.set(20, 'btn_imprimir');
        this.arrayObjetos.set(21, 'nombre_bodega');

/*         this.arrayObjetos.set(22, 'archivos2');
        this.arrayObjetos.set(23, 'archivos3');
        this.arrayObjetos.set(24, 'archivos4');
        this.arrayObjetos.set(25, 'archivos5'); */

        this.arrayObjetos.set(26, 'imagenes2');
        this.arrayObjetos.set(27, 'imagenes3');
        this.arrayObjetos.set(28, 'imagenes4');
        this.arrayObjetos.set(29, 'imagenes5');

        this.arrayObjetos.set(30, 'btn_agregar');
        this.arrayObjetos.set(31, 'btn_cancelar');
        this.arrayObjetos.set(32, 'btn_modificar');
        this.arrayObjetos.set(33, 'btn_cancelar_modificar');
        //this.arrayObjetos.set(34,'operacion');
        this.establecerPropiedades('1,2,3,4,5,6,8,10,12,13,14,15,16,17,18,19,20,21,26,27,28,29', 'visible', 'false')
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,26,27,28,29', 'disable', 'true')

        //inicio form
        this.establecerPropiedades('2,3,4,5,6,8,10,12,13,14,15,16,17,18,19,21,26,27,28,29', 'visible', 'true');
        /* this.traerPrimero(); */



        this.getField('btn_cancelar').setClick(() => {
            
            this.traer_por_id = true;
            this.registro_seleccionado = false;
            localStorage.setItem('deleteCancelar', 'false');
            this.btnCancelarRegistro();
            /* this.traerTodos(); */
            
            
        });
        this.getField('btn_agregar').setClick(() => {
            if (this.getField('codigo').valid() && this.getField('grupos_id').valid() 
                && this.getField('serialactivo').valid() && this.getField('nombre').valid() && 
                this.getField('fechacreacion').valid() && this.getField('bodega_id').valid() && this.getField('empresa_id').valid() 
                &&  this.getField('responsable_id').valid() && this.getField('series_id').valid() && this.getField('estadoactivo_id').valid()
            ){
                
                this.validacionUnique();

/*                 if (this.getField('archivos').getValue() !== "" && this.getField('imagenes').getValue() !== null 
                    && this.getField('archivos2').getValue() !== "" && this.getField('imagenes2').getValue() !== null 
                    && this.getField('archivos3').getValue() !== "" && this.getField('imagenes3').getValue() !== null 
                    && this.getField('archivos4').getValue() !== "" && this.getField('imagenes4').getValue() !== null 
                    && this.getField('archivos5').getValue() !== "" && this.getField('imagenes5').getValue() !== null 
            ) {
                console.log(' Pase la condicion imagenes archivos');
                this.validacionUnique();
            } */
    
/*                     if (!this.allowedExtensions.exec(this.archivoTXT.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten archivos con extensión .txt/.TXT./pdf', 'error');
                        this.getField('archivos').setError(false, "Formato incorrecto");
                    } else if (this.archivoTXT.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'El archivo (' + this.archivoTXT.name + ') No puede contener espacios.', 'error');
                        this.getField('archivos').setError(false);
                    
                    
                    else if (!this.allowedImagesExtensions.exec(this.archivoImagen.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes').setError(false, "Formato incorrecto");
                    } else if (this.archivoImagen.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes').setError(false, 'Contiene espacios');
                    }
                    else if (!this.allowedImagesExtensions.exec(this.archivoImagen2.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes2').setError(false, "Formato incorrecto");
                    } else if (this.archivoImagen2.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen2.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes2').setError(false, 'Contiene espacios');
                    }
                    else if (!this.allowedImagesExtensions.exec(this.archivoImagen3.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes3').setError(false, "Formato incorrecto");
                    } else if (this.archivoImagen3.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen3.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes3').setError(false, 'Contiene espacios');
                    }
                    else if (!this.allowedImagesExtensions.exec(this.archivoImagen4.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes4').setError(false, "Formato incorrecto");
                    } else if (this.archivoImagen4.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen4.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes4').setError(false, 'Contiene espacios');
                    }
                    else if (!this.allowedImagesExtensions.exec(this.archivoImagen5.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes5').setError(false, "Formato incorrecto");
                    } else if (this.archivoImagen5.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen5.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes5').setError(false, 'Contiene espacios');
                    }
                    
                    
                    else {
                        console.log(' Pase la condicion imagenes archivos');
                        this.validacionUnique();
                    }
        
                }else{
                    this.alertGeneral.toggle(true, 'Debe llenar todos los campos', 'error');
                } */

            }else{

            }
        });

        this.getField('btn_modificar').setClick(() => {
            if (
                this.getField('codigo').valid() && this.getField('serialactivo').valid() && this.getField('nombre').valid() && 
                this.getField('fechacreacion').valid() && this.getField('bodega_id').valid() && this.getField('empresa_id').valid() 
                &&  this.getField('responsable_id').valid() && this.getField('series_id').valid() && this.getField('estadoactivo_id').valid()
            )
                /* this.modificarImagenArchivo(); */
                this.eliminarModificarImagenBasicos()
                
        });

        this.getField('btn_cancelar_modificar').setClick(() => {
/*             this.traer_por_id = true;
            this.registro_seleccionado = false;
            localStorage.setItem('deleteCancelar', 'false');
            this.btnCancelarRegistro(); */
            this.traer_por_id = true;
            this.registro_seleccionado = false;
            localStorage.setItem('deleteCancelar', 'false');
            this.btnCancelarRegistro();
        });

        this.getField('btn_imprimir').setClick(this.abrirImprimir);
        //imprimir
        this.getField('radio_correo').setValue("N");
        this.getField('generar_archivo').setDisabled(false);
        this.getField('ch_excel').setDisabled(false);
        this.getField('ch_pdf').setDisabled(false);
        this.getField('radio_correo').setDisabled(false);

        this.getField('generar_archivo').setClick(() => this.procesar());

        this.getField('radio_correo').setOnChange((props) => {
            if (this.getField('radio_correo').getValue() === 'N') {
                this.getField('email').setDisabled(true);
                this.getField('email').setValue('');
                this.getField('email').setError(false, '');
            } else {
                this.getField('email').setDisabled(false);
                this.getField('email').setValue('');
                this.getField('email').setError(false, '');
            }
        });
        //para balances globales
        this.getField('ch_excel').setOnChange((props) => {
            if (this.getField('ch_excel').getValue() === 'false') {
                this.getField('ch_pdf').setValueSwitch(false);
                /* this.getField('ch_pantalla').setValueSwitch(false); */
                this.operacion_actual = 'excel';
                this.getField('radio_correo').setValue("N");

            }
        });
        this.getField('ch_pdf').setOnChange((props) => {
            if (this.getField('ch_pdf').getValue() === 'false') {
                this.getField('ch_excel').setValueSwitch(false);
               /*  this.getField('ch_pantalla').setValueSwitch(false); */
                this.operacion_actual = 'pdf';
                this.getField('radio_correo').setValue("N");
            }
        });

        this.getField('modal_imprimir').setCloseButton(() => {
            //nada
        });
        this.getField('archivos').setOnChange((props) => {
            
            (props.target.files[0] !== undefined && props.target.files[0] !== " ") ?
            this.archivoTXT = props.target.files[0]: this.archivoTXT = "";
        });

        this.getField('imagenes').setOnChange((props) => {
            ((props.target.files[0] !== undefined && props.target.files[0] !== " ")) ?
            this.archivoImagen = props.target.files[0]: this.archivoImagen = "";

        });
        this.getField('imagenes2').setOnChange((props) => {
            ((props.target.files[0] !== undefined && props.target.files[0] !== " ")) ?
            this.archivoImagen2 = props.target.files[0]: this.archivoImagen2 = "";

        });
        this.getField('imagenes3').setOnChange((props) => {
            ((props.target.files[0] !== undefined && props.target.files[0] !== " ")) ?
            this.archivoImagen3 = props.target.files[0]: this.archivoImagen3 = "";

        });
        this.getField('imagenes4').setOnChange((props) => {
            ((props.target.files[0] !== undefined && props.target.files[0] !== " ")) ?
            this.archivoImagen4 = props.target.files[0]: this.archivoImagen4 = "";

        });
        this.getField('imagenes5').setOnChange((props) => {
            ((props.target.files[0] !== undefined && props.target.files[0] !== " ")) ?
            this.archivoImagen5 = props.target.files[0]: this.archivoImagen5 = "";

        });
        this.getField('btn_change').setDisabled(true);
        
        this.traerUltimo();

    } ///fin initForm


    abrirImprimir() {
        this.getField("modal_imprimir").setLabel("Imprimir");
        this.getField('modal_imprimir').handleClickOpen();
        this.getField('email').setValue('');
        this.getField('email').setError(false, '');
        this.getField('radio_correo').setValue("N");
        this.getField('ch_excel').setValueSwitch(false);
        this.getField('ch_pdf').setValueSwitch(false);
        /* this.getField('ch_pantalla').setValueSwitch(false); */
    }

    onSelectionChanged() {
        let filaSeleccionada = this.gridOptionsTableDefault.api.getSelectedRows();
        if (filaSeleccionada.length > 0) {
            this.llenar(filaSeleccionada);
            this.registro_seleccionado = true;
            localStorage.setItem('deleteCancelar', 'true');
        } else {
            this.registro_seleccionado = false;
            localStorage.setItem('deleteCancelar', 'false');
        }
    }

    handerClickShowTable() {
        this.filterTextLoweCase = "";
        this.columnSelected  = "";
        this.filter_numero_aux='';
        this.filter_numero_documento=false;
        this.registro_seleccionado = false;
        localStorage.setItem('deleteCancelar', 'false');
        this.traer_por_id = false;
        this.traerTodos();
    }

    handlerClickChange() {
        this.btnModificar = true;
        let deleteCancelar = (localStorage.getItem('deleteCancelar') === 'true') ? true: false;
        if (deleteCancelar) {
            this.registro_seleccionado = false;
            /* this.establecerPropiedades('1,4,6,7,8,9,10,11,15,17,19,32,33', 'disable', 'false'); */
            this.establecerPropiedades('1,6,7,9,11,13,14,26,27,28,29,32,33', 'disable', 'false');
            this.establecerPropiedades('32,33', 'visible', 'true');
            this.getField('btn_new').setVisible(false);
            this.getField('btn_show').setVisible(false);
            this.getField('btn_change').setVisible(false);
            this.getField('btn_delete').setVisible(false);
            this.getField('rejilla').toggle(false);
            this.getField('btn_imprimir').setVisible(false);
            localStorage.setItem('deleteCancelar', 'false');
        } else if (this.registro_seleccionado) {
            this.registro_seleccionado = false;
            /* this.establecerPropiedades('1,4,5,6,7,8,9,10,11,15,17,19,32,33', 'disable', 'false'); */
            this.establecerPropiedades('1,5,7,9,11,13,14,26,27,28,29,32,33', 'disable', 'false');
            this.establecerPropiedades('32,33', 'visible', 'true');
            this.getField('btn_new').setVisible(false);
            this.getField('btn_show').setVisible(false);
            this.getField('btn_change').setVisible(false);
            this.getField('btn_delete').setVisible(false);
            this.getField('rejilla').toggle(false);
            this.getField('btn_imprimir').setVisible(false);
            localStorage.setItem('deleteCancelar', 'false');
        } else {
            this.mostrarMensajeSeleccionModificar();
        }

    }

    handlerClickNew() {
        this.btnModificar = false;
        this.registro_seleccionado = false;
        localStorage.setItem('deleteCancelar', 'false');
        this.establecerPropiedades('1,2,3,4,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29,30,31', 'disable', 'false');
        this.establecerPropiedades('30,31', 'visible', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29', 'value', '');

        this.getField('btn_new').setVisible(false);
        this.getField('btn_show').setVisible(false);
        this.getField('btn_change').setVisible(false);
        this.getField('btn_delete').setVisible(false);
        this.getField('rejilla').toggle(false);
        this.getField('btn_imprimir').setVisible(false);

    }

    handlerClickDelete() {
        this.traer_por_id = false;
        let deleteCancelar = (localStorage.getItem('deleteCancelar') === 'true') ? true: false;

        if (deleteCancelar) {
            this.confirmarEliminacionRegistro();
            this.registro_seleccionado = false;
            localStorage.setItem('deleteCancelar', 'false');
        } else if (this.registro_seleccionado) {
            this.confirmarEliminacionRegistro();
            this.registro_seleccionado = false;
            localStorage.setItem('deleteCancelar', 'false');
        } else {
            this.mostrarMensajeSeleccionEliminar();
            this.registro_seleccionado = false;
            localStorage.setItem('deleteCancelar', 'false');

        }
    }

    mostrarMensajeSeleccionModificar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para modificar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeSeleccionEliminar() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No se ha seleccionado ningún registro para eliminar');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    btnCancelarRegistro() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('btn_agregar').setVisible(false);
        this.getField('btn_cancelar').setVisible(false);
        this.getField('btn_modificar').setVisible(false);
        this.getField('btn_cancelar_modificar').setVisible(false);
        this.getField('btn_new').setDisabled(false);
        this.getField('btn_show').setDisabled(false);
        this.getField('btn_delete').setDisabled(false);
        
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29', 'disable', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29', 'value', '');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29', 'error', 'false');
/*         this.registro_seleccionado = false;
        localStorage.setItem('deleteCancelar', 'false'); */

        if (this.traer_por_id)
            this.traerPorId();
        
/*         else
            console.log('entre al else '); */
            /* this.traerPrimero(); */
        this.traerTodos();
        this.traerUltimo();


        this.getField('btn_new').setVisible(true);
        this.getField('btn_show').setVisible(true);
        this.getField('btn_change').setVisible(true);
        this.getField('btn_delete').setVisible(true);

/*         this.gridOptionsTableDefault["rowData"] = [];
        this.getField('rejilla').initData(this.gridOptionsTableDefault);
        this.getField('rejilla').toggle(false);
        this.btnModificar = false; */
    }

    btnCancelarRegistroModificar() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('btn_agregar').setVisible(false);
        this.getField('btn_cancelar').setVisible(false);
        this.getField('btn_modificar').setVisible(false);
        this.getField('btn_cancelar_modificar').setVisible(false);
        this.getField('btn_new').setDisabled(false);
        this.getField('btn_show').setDisabled(false);
        this.getField('btn_delete').setDisabled(false);
        
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29', 'disable', 'true');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29', 'value', '');
        this.establecerPropiedades('1,2,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,26,27,28,29', 'error', 'false');
/*         this.registro_seleccionado = false;
        localStorage.setItem('deleteCancelar', 'false'); */


        this.traerTodos();
        /* this.traerPorId(); */


        this.getField('btn_new').setVisible(true);
        this.getField('btn_show').setVisible(true);
        this.getField('btn_change').setVisible(true);
        this.getField('btn_delete').setVisible(true);

    }

    validacionUnique() {
        if (this.getField('codigo').getValue() !== '' && this.getField('codigo').getValue() !== ' ' && 
        this.getField('serialactivo').getValue() !== '' && this.getField('serialactivo').getValue() !== ' ')
         {
            let datos = {
                datos: {
                    codigo: this.getField('codigo').getValue(),
                    serialactivo: this.getField('serialactivo').getValue(),
                }
            };
            let operacion = '20';
            if (this.btnModificar) {
                datos.datos['activos_fijos_basicos_logisticos_id'] = this.getField('activos_fijos_basicos_logisticos_id').getValue();
                operacion = '20_modificar';
            }
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: operacion, operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successValidarUniqueRegistro,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
        
    }


    successValidarUniqueRegistro(data) {
        
        if (data.estado_p === 200) {
            this.alertGeneral.toggle(true, 'Este Código ya está asociado a otro registro.', 'error');
        }
        else {
            if (data.estado_p === 404) {
                if (this.btnModificar) {
                    this.actualiarRegistro();

                } else {
                    this.crearRegistro();
                }
            }
        }
    }

    eliminarModificarImagenBasicos(){
        if (this.btnModificar) {
            if (this.getField('activos_fijos_basicos_logisticos_id').getValue() !== '' && 
            this.getField('activos_fijos_basicos_logisticos_id').getValue() !== ' ' 
            && this.getField('activos_fijos_basicos_logisticos_id').getValue() !== null) {


                if ( this.archivoTXT === this.archivoModificar && this.archivoImagen === this.imagenModificar 
                    && this.archivoImagen2 === this.imagenModificar2 && this.archivoImagen3 === this.imagenModificar3
                    && this.archivoImagen4 === this.imagenModificar4 && this.archivoImagen5 === this.imagenModificar5     ) {
                        this.alertGeneral.toggle(true, 'No hay nada para modificar', 'success');
                        this.arrayImagesArchiveEliminar = [];
                        this.arrayImagesArchiveActualizar = [];
                } else {

                    if(this.archivoTXT !== this.archivoModificar){
                        this.arrayImagesArchiveEliminar.push({'column': 'archivos','archivos': this.archivoModificar});
                        
                        this.arrayImagesArchiveActualizar.push( {'column':'archivos','archivos': this.archivoTXT})

                    } 
                     if(this.archivoImagen !== this.imagenModificar){
                        this.arrayImagesArchiveEliminar.push({'column': 'imagen','imagen': this.imagenModificar});
                        
                        this.arrayImagesArchiveActualizar.push( {'column':'imagen','imagen': this.archivoImagen})
                    }
                     if(this.archivoImagen2 !== this.imagenModificar2){
                        this.arrayImagesArchiveEliminar.push({'column': 'imagen2','imagen': this.imagenModificar2});
                        
                        this.arrayImagesArchiveActualizar.push( {'column':'imagen2','imagen': this.archivoImagen2})
                    }
                     if(this.archivoImagen3 !== this.imagenModificar3){
                        this.arrayImagesArchiveEliminar.push({'column': 'imagen3','imagen': this.imagenModificar3});
                        
                        this.arrayImagesArchiveActualizar.push( {'column':'imagen3','imagen': this.archivoImagen3})
                    }
                     if(this.archivoImagen4 !== this.imagenModificar4){
                        this.arrayImagesArchiveEliminar.push({'column': 'imagen4','imagen': this.imagenModificar4});
                        
                        this.arrayImagesArchiveActualizar.push( {'column':'imagen4','imagen': this.archivoImagen4})
                    }
                     if(this.archivoImagen5 !== this.imagenModificar5){
                        this.arrayImagesArchiveEliminar.push({'column': 'imagen5','imagen': this.imagenModificar5});
                        
                        this.arrayImagesArchiveActualizar.push( {'column':'imagen5','imagen': this.archivoImagen5})
                    }

                    

                    const datos = {
                        datos : {
                            array_archives_delete : this.arrayImagesArchiveEliminar,
                            activos_fijos_basicos_logisticos_id: this.getField('activos_fijos_basicos_logisticos_id').getValue()
                        }
                    }
                    this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog',
                         operacion: 'eliminar_modificar_archivo_basicos', operacion_tipo: 'eliminar' };
                    this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'GET',
                        body: datos,
                        success: this.successEliminarModificarImagenBasicos,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });
                    
                }





            }
        }

    }

    successEliminarModificarImagenBasicos(data){
        
        if (data.estado_p === 200) {
            this.arrayImagesArchiveEliminar = [];
            
        }
    }



    modificarImagenArchivo(){
        if (this.btnModificar) {
            if (this.getField('activos_fijos_basicos_logisticos_id').getValue() !== '' && 
            this.getField('activos_fijos_basicos_logisticos_id').getValue() !== ' ' 
            && this.getField('activos_fijos_basicos_logisticos_id').getValue() !== null) {

                if (this.getField('archivos').getValue() !== "" && this.getField('imagenes').getValue() !== null) {
        
                    if (!this.allowedExtensions.exec(this.archivoTXT.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten archivos con extensión .txt/.TXT./pdf', 'error');
                        this.getField('archivos').setError(false, "Formato incorrecto");
                    } else if (this.archivoTXT.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'El archivo (' + this.archivoTXT.name + ') No puede contener espacios.', 'error');
                        this.getField('archivos').setError(false);
                    } else if (!this.allowedImagesExtensions.exec(this.archivoImagen.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes').setError(false, "Formato incorrecto");
                    } else if (this.archivoImagen.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes').setError(false, 'Contiene espacios');
                    }else {

                        const data = {
                            _generales: { "tipo_servicio": "serlog-activosfijosbasicoslog", "operacion": "modificar_imagen_basicos", 
                                "operacion_tipo": "modificar" },
                            activos_fijos_basicos_logisticos_id: parseInt(this.getField('activos_fijos_basicos_logisticos_id').getValue()),
                            archivo_eliminar: this.archivoModificar,
                            imagen_eliminar: this.imagenModificar,
                            archivo: this.archivoTXT,
                            imagen: this.archivoImagen,
                        }

                        
                        
                        
                        let url = this.constant.formConfiguration();
                        this.generalFormat = data._generales;
                        this.service.send({
                            endpoint: url,
                            method: 'PUT',
                            body: data,
                            success: this.successActualizar,
                            error: this.error_,
                            general: this.generalFormat,
                            formData: true,
                            showMessage: false
                        });
                        
                       

                        
                    }
        
                }else{
                    this.alertGeneral.toggle(true, 'Debe llenar todos los campos', 'error');
                }
    
            }else{
                this.alertGeneral.toggle(true, 'Error modificando este registro', 'error');
            }
        }else{
            this.alertGeneral.toggle(true, 'No ha seleccionado ningún registro', 'error');
        
        }
        


    }

    traerPorId() {

        let id_activo_basico = (this.getField('activos_fijos_basicos_logisticos_id').getValue() === null 
        || this.getField('activos_fijos_basicos_logisticos_id').getValue() === ''
        || this.getField('activos_fijos_basicos_logisticos_id').getValue() === ' ') 
        ? parseInt(localStorage.getItem('activos_fijos_basicos_logisticos_id'))
        : this.getField('activos_fijos_basicos_logisticos_id').getValue() ;


        
        if (id_activo_basico !== null && id_activo_basico !== '' &&
             id_activo_basico !== ' ') {
                
            let datos = {
                datos: {
                    activos_fijos_basicos_logisticos_id: id_activo_basico
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: '2', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successtraerPorId,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successtraerPorId(data) {
        if (data.estado_p === 200) {
             
            this.llenar(data.data)
        }

    }

    confirmarEliminacionRegistro() {
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
        this.getField('confirmModalCustom').setClickDialog(this.validarRegistroEliminar);
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
            this.getField('confirmModalCustom').toggle(false);
            this.registro_seleccionado = true;
            localStorage.setItem('deleteCancelar', 'true');
             });
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
        this.getField('confirmModalCustom').toggle(true);
    }

    validarRegistroEliminar() {
        this.getField('confirmModalCustom').toggle(false);

        this.eliminarPorId();
    }

    succesvalidarRegistroEliminar(data) {
        if (data.data[0].cuantos === 0) {
            this.eliminarPorId();

        } else {
            this.alertGeneral.toggle(true, '* Este exoformatoid existe en alguno(s) exogena_formatos_conceptos_columnas, no se permite eliminar', 'error')
            this.getField('confirmModalCustom').toggle(false);

        }
    }

    eliminarPorId() {        
        const datos = {
            datos : {
                nombre_archivo: this.archivoTXT,
                nombre_imagen: this.archivoImagen,
                activos_fijos_basicos_logisticos_id: this.getField('activos_fijos_basicos_logisticos_id').getValue()
            }
        }



        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: 'eliminar_basicos', operacion_tipo: 'eliminar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: datos,
            success: this.successeliminarPorId,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });

    }

    successeliminarPorId(data) {
        if (data.estado_p === 200) {
            this.getField('confirmModalCustom').toggle(false);
            this.traerPrimero();
            this.traerTodos();
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            }
            else {
/*                 let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores); */
                if(data.data.hasOwnProperty('mensaje')){
                    this.alertGeneral.toggle(true, data.data.mensaje, 'error');
                }else {
                    this.alertGeneral.toggle(true, 'error eliminando los registros', 'error');
                }
            }
        }
    }

    crearRegistro() {
        
        if (this.getField('archivos').getValue() !== ""){
            this.arrayArchive.push(this.archivoTXT)    
        }
        
        if(this.getField('imagenes').getValue() !== ""){
            this.arrayImages.push( {'column':'imagen' ,'imagen': this.archivoImagen})
        }
        if(this.getField('imagenes2').getValue() !== ""){
            this.arrayImages.push( {'column':'imagen2', 'imagen': this.archivoImagen2})
        }
        if(this.getField('imagenes3').getValue() !== ""){
            this.arrayImages.push( {'column':'imagen3','imagen': this.archivoImagen3})
        }
        if(this.getField('imagenes4').getValue() !== ""){
            this.arrayImages.push({'column':'imagen4', 'imagen': this.archivoImagen4})
        }
        if(this.getField('imagenes5').getValue() !== ""){
            this.arrayImages.push( {'column':'imagen5', 'imagen': this.archivoImagen5});
        }

        

        if (this.getField('archivos').getValue() !== "" /* || this.getField('archivos2').getValue() !== "" || this.getField('archivos3').getValue() !== ""
            || this.getField('archivos4').getValue() !== "" || this.getField('archivos5').getValue() !== ""  */
            && (this.getField('imagenes').getValue() !== "" || this.getField('imagenes2').getValue() !== "" || this.getField('imagenes3').getValue() !== ""
            || this.getField('imagenes4').getValue() !== "" || this.getField('imagenes5').getValue() !== "")
            ) {
            const data = {
                _generales: { "tipo_servicio": "serlog-activosfijosbasicoslog", "operacion": "subirarchivo_basicos", "operacion_tipo": "crear" },
                codigo: this.getField('codigo').getValue(),
                serialactivo: this.getField('serialactivo').getValue(),
                nombre: (this.getField('nombre').getValue()),
                fechacreacion: this.getField('fechacreacion').getValue(),
                estadoactivo_id: this.getField('estadoactivo_id').getValue(),
                bodega_id: this.getField('bodega_id').getValue(),
                empresa_id: this.getField('empresa_id').getValue(),
                grupos_id: this.getField('grupos_id').getValue(),
                responsable_id: this.getField('responsable_id').getValue(),
                series_id: this.getField('series_id').getValue(),
                archivo: /* this.archivoTXT */'',
                imagen:  /* this.archivoImagen */'',
                imagen2: /* this.archivoImagen2 */'',
                imagen3: /* this.archivoImagen3 */'',
                imagen4: /* this.archivoImagen4 */'',
                imagen5: /* this.archivoImagen5 */'',
            }
            
            
            if (this.archivoTXT !== '') {
                data.archivo = this.archivoTXT;
                let url = this.constant.formConfiguration();
                this.generalFormat = data._generales;

                this.service.send({
                            endpoint: url,
                            method: 'POST',
                            body: data,
                            success: this.successSubirTXT,
                            error: this.error_,
                            general: this.generalFormat,
                            formData: true,
                            showMessage: false
                });
                
            } else {
                this.alertGeneral.toggle(true, 'Debe ingresar un archivo', 'error' );
            }

        }else{

            this.alertGeneral.toggle(true, 'Debe enviar al menos 1 archivo y 1 imagen', 'error' );
        }
    
    }


    objectSendArchiveImage(){
        

        /* this.id = data.data[0].id; */
        
        this.contador = 0;
        
        


        if(this.obtenerImagen('imagen').name !== '') {
            
           this.objectSendImage('imagen', this.obtenerImagen('imagen'));
        
        }
        
        if(this.obtenerImagen('imagen2').name !== '') {
            this.objectSendImage('imagen2', this.obtenerImagen('imagen2'));
        
        }
        
        if(this.obtenerImagen('imagen3').name !== '') {
            this.objectSendImage('imagen3', this.obtenerImagen('imagen3'));
        
        }
        
        if(this.obtenerImagen('imagen4').name !== '') {
            this.objectSendImage('imagen4', this.obtenerImagen('imagen4'));
        
        }
        
        if(this.obtenerImagen('imagen5').name !== '') {
            this.objectSendImage('imagen5', this.obtenerImagen('imagen5'));
        }

    }
    objectSendImage(column, imagen){
        
        const data = {
            _generales: { "tipo_servicio": "serlog-activosfijosbasicoslog", "operacion": "subir_imagen_basicos", "operacion_tipo": "crear"  },
            imagen: imagen,
            column: column,
            id: this.id,
        }

        let url = this.constant.formConfiguration();
        this.generalFormat = data._generales;
        this.service.send({
            endpoint: url,
            method: 'POST',
            body: data,
            success: this.successSubirImagen,
            error: this.error_,
            general: this.generalFormat,
            formData: true,
            showMessage: false
        });

    }


    successSubirImagen(data){
        this.contador += 1;
        


        if (data.estado_p === 200) {

            if(this.contador === this.arrayImages.length){
                
                this.getField('activos_fijos_basicos_logisticos_id').setValue(data.data['activos_fijos_basicos_logisticos_id'].activos_fijos_basicos_logisticos_id);
                localStorage.setItem('activos_fijos_basicos_logisticos_id', this.getField('activos_fijos_basicos_logisticos_id').getValue() );
                this.traer_por_id = true;
                this.btnCancelarRegistro();
                this.traerUltimo();
                this.contador = 0;
                this.arrayImages = [];
                this.btnModificar = true;
                if (this.mensajeError.length > 0) {
                    this.mostrarMensajeAdicional(this.mensajeError)
                } 
    
            }

        }else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'Error', 'error');
            }
            else {
                this.arrayArchive = [];
                this.arrayImages = [];
                let respuesta = Object.values(data.data.errores);
                if (respuesta.toString().includes('El nombre de la imagen es demasiado grande.')) {
                    this.mensajeError += respuesta[0];
                } else if (respuesta.toString().includes('El nombre del archivo es demasiado grande.')) {
                    this.mensajeError += respuesta[0];
                } 
            }
        };
/*         if(this.contador === 4){
            console.log('llegue a la respuesta de crear el archivo ');
            this.getField('activos_fijos_basicos_logisticos_id').setValue(data.data[0].activos_fijos_basicos_logisticos_id);
            localStorage.setItem('activos_fijos_basicos_logisticos_id', this.getField('activos_fijos_basicos_logisticos_id').getValue() );
            this.traer_por_id = true;
            this.btnCancelarRegistro();
            this.traerUltimo();
            this.btnModificar = true;
            if (this.mensajeError.length > 0) {
                this.mostrarMensajeAdicional(this.mensajeError)
            } 

        } */

    } 



    obtenerImagen(keyImage){
        let getImage = {'name': ''};
        for (let index = 0; index < this.arrayImages.length; index++) {
            const image = this.arrayImages[index];

            if (keyImage === image.column) {
                
                getImage = structuredClone(image.imagen)
                break;
            } 

/*             getImage = Object.entries(image).map(([key, value]) => {
                console.log('key dentro del mapa ', keyImage);
                console.log('archivo dentro del mapa ', image);
                return (keyImage === key) ? image[keyImage] : { name: '' };
            }); */
            
        }
        

        return getImage;

    }



    successSubirTXT(data){
        
        if (data.estado_p === 200) {
            this.getField('activos_fijos_basicos_logisticos_id').setValue(data.data[0].activos_fijos_basicos_logisticos_id);
            localStorage.setItem('activos_fijos_basicos_logisticos_id', this.getField('activos_fijos_basicos_logisticos_id').getValue() );
            
            this.id = data.data[0].activos_fijos_basicos_logisticos_id;
            
            this.contador = 0;
            this.objectSendArchiveImage();

        }

    } 




    successCrear(data) {
        if (data.estado_p === 200) {
            
            this.getField('activos_fijos_basicos_logisticos_id').setValue(data.data[0].activos_fijos_basicos_logisticos_id);
            localStorage.setItem('activos_fijos_basicos_logisticos_id', this.getField('activos_fijos_basicos_logisticos_id').getValue() );
            this.traer_por_id = true;
            this.btnCancelarRegistro();
            this.traerUltimo();
/*             this.registro_seleccionado = true;
            localStorage.setItem('deleteCancelar', 'true'); */
            this.btnModificar = true;
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'Error', 'error');
            }
            else {
                this.arrayArchive = [];
                this.arrayImages = [];
                let respuesta = Object.values(data.data.errores);
                let mensajeError = 'Error ';
                if (respuesta.toString().includes('El nombre de la imagen es demasiado grande.')) {
                    mensajeError = respuesta[0];
                } else if (respuesta.toString().includes('El nombre del archivo es demasiado grande.')) {
                    mensajeError = respuesta[0];
                } else if (respuesta.toString().includes('"activos_fijos_basicos_logisticos_codigo_key"')) {
                    mensajeError = 'El código ya está asociado a un registro';
                }else{
                    mensajeError = ' Este serial ya está asociado a un registro'  
                } 
                this.alertGeneral.toggle(true, mensajeError , 'error');
            }
        };
    }



    actualiarRegistro() {
        if (this.getField('activos_fijos_basicos_logisticos_id').getValue() !== '' && this.getField('activos_fijos_basicos_logisticos_id').getValue() !== ' ' && this.getField('activos_fijos_basicos_logisticos_id').getValue() !== null) {
            let datos = {
                datos: {
                    activos_fijos_basicos_logisticos_id: parseInt(this.getField('activos_fijos_basicos_logisticos_id').getValue()),
                    codigo: this.getField('codigo').getValue(),
                    serialactivo: this.getField('serialactivo').getValue(),
                    nombre: this.getField('nombre').getValue(),
                    fechacreacion: this.getField('fechacreacion').getValue(),
                    estadoactivo_id: parseInt(this.getField('estadoactivo_id').getValue()),
                    bodega_id: parseInt(this.getField('bodega_id').getValue()),
                    empresa_id: parseInt(this.getField('empresa_id').getValue()),
                    grupos_id: parseInt(this.getField('grupos_id').getValue()),
                    responsable_id: parseInt(this.getField('responsable_id').getValue()),
                    series_id: parseInt(this.getField('series_id').getValue()),
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: '6', operacion_tipo: 'modificar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: datos,
                    success: this.successActualizar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    successActualizar(data) {
        
        if (data.estado_p === 200) {
            this.getField('activos_fijos_basicos_logisticos_id').setValue(data.data[0].activos_fijos_basicos_logisticos_id);
            localStorage.setItem('activos_fijos_basicos_logisticos_id', this.getField('activos_fijos_basicos_logisticos_id').getValue().toString());

            this.traer_por_id = true;
            this.btnModificar = true;
            this.archivoModificar = '';
            this.imagenModificar = '';
            this.imagenModificar2 = '';
            this.imagenModificar3 = '';
            this.imagenModificar4 = '';
            this.imagenModificar5 = '';
            /* this.traerUltimo(); */
/*             this.traerPrimero(); */
            
            this.btnCancelarRegistro();
            this.traerPorId();
            

        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'Error', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'No se pudo actualizar el registro', 'error');
            }
        };
/*         if (data.estado_p === 200) {
            this.getField('activos_fijos_basicos_logisticos_id').setValue(data.data[0].activos_fijos_basicos_logisticos_id);
            localStorage.setItem('activos_fijos_basicos_logisticos_id', this.getField('activos_fijos_basicos_logisticos_id').getValue().toString());

            this.traer_por_id = true;
            this.btnModificar = true;

            
            this.btnCancelarRegistro();
            this.traerPorId();
            

        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'Error', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'No se pudo actualizar el registro', 'error');
            }
        }; */
    }

    //metodos conceptos

    traerTodos() {
        localStorage.setItem('columnB','');
        let datos = { datos: {} };
/*         this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: '1_1', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerTodos,
                error: this.error_,
                general: this.generalFormatPmv
            }); */
        this.getField("rejilla").setTipoServicioOperacion('serlog-activosfijosbasicoslog-1_1');
        this.getField("rejilla").sendRequest(this.successtraerTodos, datos);
    }

    successtraerTodos(data) {
        this.columnSelected  = "";
        this.gridOptionsTableDefault['onSelectionChanged'] = [];
        this.gridOptionsTableDefault['rowData'] = [];
        let configCell = new Map();
                    
        configCell.set("codigo",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set("serialactivo",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set("nombre_serie",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });
        configCell.set("nombre",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set("codigobodega",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set("descripcion_bodega",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set("fechacreacion",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set("nombre_grupo_serie",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set("nombre_grupo",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });
        configCell.set("codigo_grupo",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });
        configCell.set("codigo_grupo_serie",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });
        configCell.set("estado_grupo",{
            filter: "agTextColumnFilter",
            filterParams: {
                filterOptions: ['contains'],
                buttons: ['apply'],
                suppressAndOrCondition: true,
                closeOnApply: true,
                textCustomComparator:  (filter, value, filterText) => {
                    this.filter_numero_aux = filterText.toLowerCase();
                    return true;
                },
                debounceMs: 200,
                maxNumConditions: 1,
            }
        });

        configCell.set('activos_fijos_basicos_logisticos_id', { cellRenderer: (props) => { return "" + props.data.activos_fijos_basicos_logisticos_id }, hide: true });
        

        if (data.estado_p === 200 && data.data.length > 0) {
            //armar tabla
            
            
            this.gridOptionsTableDefault['rowData'] = data.model;//los datos del servicio se cargan en la tabla por defecto del crud
            this.gridOptionsTableDefault['onSelectionChanged'] = this.onSelectionChanged;



            this.gridOptionsTableDefault.onFilterChanged = (event) => this.sqlFilterTable(event)
            this.gridOptionsTableDefault.onFilterModified = (event) =>  this.getValueFilterColumn(event);
            this.gridOptionsTableDefault.enableCellTextSelection = true;

            configCell.set('accion', { cellRenderer: this.setButtonTableActivosFijosBasicos, headerName: 'Acción', width: 400, sortable: false, filter: false });

            this.getField('rejilla').initData(this.gridOptionsTableDefault, configCell);
            this.getField('btn_imprimir').setVisible(true);
            this.getField('btn_imprimir').setDisabled(false);

/*            
            this.registro_seleccionado = true; */
        } else {
            if(this.gridOptionsTableDefault.api !== undefined){
                
                this.gridOptionsTableDefault.api.setFilterModel(null);
            }
            
            this.gridOptionsTableDefault.api.setFilterModel(null);
            this.filterTextLoweCase = "";
            this.columnSelected  = "";
            localStorage.setItem('columnB','');

            this.filter_numero_documento=false;

            this.gridOptionsTableDefault['rowData'] = [];
            this.getField('rejilla').initData(this.gridOptionsTableDefault, configCell);

            this.filter_numero_documento= false;
            this.getField('btn_imprimir').setVisible(false);
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'No se encontraron registros', 'error');
            }
        }
    }


    /**
     * Establece la creación del botón en la tabla
     * @param {Contiene los valores de la fila seleccionada en la tabla} props 
     */
    setButtonTableActivosFijosBasicos(props) {
        try {
            let fragment = document.createDocumentFragment();
            let buttonImage = this.crearBotonTabla(props.data, 'Ver Imagen');
            let buttonArchive = this.crearBotonTabla(props.data, 'Archivos');
            fragment.appendChild(buttonImage);
            fragment.appendChild(buttonArchive);
            return this.createElementJaivana(fragment)
        } catch (error) {

        }
    }


    crearBotonTabla(data, nombreBoton) {
        
        let button = document.createElement('input');
        button.onclick = () => { this.accionVerImagen(data) };
        switch (nombreBoton) {
            case 'Ver Imagen':
                if (data.imagenes !== undefined && data.imagenes !== null && data.imagenes !== "" && data.imagenes !== ".") {
                    button.setAttribute("class", "buttonStyleImg");
                    button.onclick = () => { this.accionVerImagen(data) };
                } else {
                    
                    /* button.setAttribute("style", "{width: 110px;height: 20px;background-color: #303f9f;color: #fff;border: 1px solid #303f9f;padding-left: 5px;padding-right: 5px;padding-top: 2px;padding-bottom: 2px;border-radius: 3px;cursor: pointer;margin-right: 10px;}"); */
                    button.setAttribute("class", '{ backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: "rgb(0, 86, 201)" }');
                    button.setAttribute("class", "buttonDisabled");
                    button.setAttribute("disabled", true);
                    button.onclick = () => { };
                }
                break;
            default: 
                if (data.archivos !== undefined && data.archivos !== null && data.archivos !== "" && data.archivos !== ".") {
                    button.setAttribute("class", "buttonStyleActivos");
                    button.onclick = () => { this.accionVerArchivo(data) };
                } else {
                    button.setAttribute("class", "buttonStyleImgDisabled2");
                    button.setAttribute("disabled", true);
                    button.onclick = () => { };
                }
                break;
        }
        button.setAttribute('value', nombreBoton);
        button.setAttribute('type', 'button');
        button.setAttribute("class", "buttonStyle2");
        button.setAttribute("id", `buttonVerImagen_${data.id}`);
        return button;

    }



    /**
     * Botón para ver el archivo de la tabla
     * @param {El objeto seleccionado en la tabla} data 
     */
    accionVerArchivo(data) {
        this.mostrarMensajeGenerando();
        let operation = "url_archivo_basicos";
        let nameArchivo = data.archivos;
        let urlArchivo = 'http://calidad.jaivanaweb.co:8084/remote.php/dav/files/admin/archivos_logisticos_activos_fijos_basicos/' + nameArchivo;
        
        let urlLocal = this.constant.formConfiguration();
        let datos = `?body={"datos":{"url":"${urlArchivo}"},"generales":{"tipo_servicio":"serlog-activosfijosbasicoslog","operacion":"${operation}","operacion_tipo":"consulta"}}`;

        fetch(urlLocal + datos, {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                })
            })
            .then(response => {
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();

                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .catch(error => {
            })
            .then(stream => new Response(stream))
            .catch(error => {
            })
            .then(response => {
                return response.blob()
            })
            .catch(error => {
            })
            .then(blob => {

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = nameArchivo;
                /* a.download = nameArchivo[2]; */
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                this.getField('confirmModalCustom').toggle(false); // cuando responda 200 debe ir en false
            })
            .catch(err => {
                return console.error(err);
            });
    }



    /**
     * Acción del botón ver imagen para ver la imagen cargada
     */
    accionVerImagen(data) {
        this.mostrarMensajeGenerando();
        let nameImage = data.imagenes;
        let urlImage = 'http://calidad.jaivanaweb.co:8084/remote.php/dav/files/admin/img_logisticos_activos_fijos_basicos/' + nameImage;
        let url = this.constant.formConfiguration();
        let datos = `?body={"datos":{"url":"${urlImage}"},"generales":{"tipo_servicio":"serlog-activosfijosbasicoslog","operacion":"url_imagen_basicos","operacion_tipo":"consulta"}}`;

        fetch(url + datos, {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                })
            })
            .then(response => {
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();

                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .catch(error => {
            })
            .then(stream => new Response(stream))
            .catch(error => {
            })
            .then(response => {
                return response.blob()
            })
            .catch(error => {
            })
            .then(blob => {
                if (blob.size > 0) {
                    const image = new File([blob], "name.jpeg", {
                        type: "image/jpeg",

                    });
                    window.open(URL.createObjectURL(image))
                } else {
                    this.alertGeneral.toggle(true, 'No hay datos', 'error');
                }
                this.getField('confirmModalCustom').toggle(false); // cuando responda 200 debe ir en false
            })
            .catch(err => {
                return console.error(err);
            });

    }






    traerPrimero() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: '3', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerPrimero,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    llenar(data) {
        
        /* this.btnModificar =true; */
        /* this.registro_seleccionado = true; */
        this.archivoModificar = structuredClone(data[0].archivos);
        this.imagenModificar = structuredClone(data[0].imagen);
        this.imagenModificar2 = structuredClone(data[0].imagen2);
        this.imagenModificar3 = structuredClone(data[0].imagen3);
        this.imagenModificar4 = structuredClone(data[0].imagen4);
        this.imagenModificar5 = structuredClone(data[0].imagen5);
        this.getField('activos_fijos_basicos_logisticos_id').setValue(data[0].activos_fijos_basicos_logisticos_id);
        this.getField('codigo').setValue(data[0].codigo);
        this.getField('serialactivo').setValue(data[0].serialactivo);
        this.getField('nombre').setValue(data[0].nombre);
        this.getField('fechacreacion').setValue(data[0].fechacreacion);
        this.getField('estadoactivo_id').setValue(data[0].estadoactivo_id);
        this.getField('bodega_id').setValue(data[0].bodega_id);
        this.getField('empresa_id').setValue(data[0].empresa_id);
        this.getField('grupos_id').setValue(data[0].grupos_id);
        this.getField('responsable_id').setValue(data[0].responsable_id);
        this.getField('series_id').setValue(data[0].series_id);
        this.getField('codigo_grupo').setValue(data[0].codigo_grupo);
        this.getField('nombre_grupo').setValue(data[0].nombre_grupo);
        this.getField('codigo_serie').setValue(data[0].codigo_serie);
        this.getField('nombre_serie').setValue(data[0].nombre_serie);
        this.getField('codigo_bodega').setValue(data[0].codigobodega);
        this.getField('nombre_bodega').setValue(data[0].descripcion_bodega);
        this.archivoTXT = (data[0].archivos !== null)? data[0].archivos : '';
        this.archivoImagen = (data[0].imagen !== null)? data[0].imagen : '';
        this.archivoImagen2 = (data[0].imagen2 !== null)? data[0].imagen2 : '';
        this.archivoImagen3 = (data[0].imagen3 !== null)? data[0].imagen3 : '';
        this.archivoImagen4 = (data[0].imagen4 !== null)? data[0].imagen4 : '';
        this.archivoImagen5 = (data[0].imagen5 !== null)? data[0].imagen5 : '';
        

/*         this.getField('archivos').setValue(data[0].archivos);
        this.getField('imagenes').setValue(data[0].imagenes); */
    }

    successtraerPrimero(data) {
        if (data.estado_p === 200) {

            this.llenar(data.data);
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }
            else {
                this.alertGeneral.toggle(true, 'Error obteniendo el registro', 'error');
            }
        }
    }


    traerUltimo() {
        let datos = { datos: {} };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: '4', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successtraerPrimero,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successtraerUltimo(data) {
        if (data.estado_p === 200) {

            this.llenar(data.data);
        }
        else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No se encontro.', 'error');
            }

        }
    }


    establecerPropiedades(sObjetos, sPropiedad, sValor) {
        const array = sObjetos.split(',');
        array.forEach((element) => {
            if (sPropiedad === 'disable') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setDisabled(false);
                }
            }
            else if (sPropiedad === 'visible') {
                if (sValor === 'true') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(true);
                }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setVisible(false);
                }
            }
            else if (sPropiedad === 'value') {
                this.getField(this.arrayObjetos.get(parseInt(element))).setValue(sValor);
            }
            else if (sPropiedad === 'valid') {
                if (this.getField(this.arrayObjetos.get(parseInt(element))).isValid()) {
                    //ok
                }
                else {
                    this.bHayErrores = true;
                }
            }
            else if (sPropiedad === 'foco') {
                if (sValor === 'rejilla') { }
                else {
                    this.getField(this.arrayObjetos.get(parseInt(element))).input.focus();
                }
            }
            else if (sPropiedad === 'error') {
                if (sValor === 'false') {
                    this.getField(this.arrayObjetos.get(parseInt(element))).setError(false, '');
                }
            }
        });
    }

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > 2) {
                decimal = (Number(number).toFixed(2) + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    //imprimir------->

    procesar(){
        let errores =0;
        if(this.getField('radio_correo').getValue()==='S'){
            if(this.getField('email').valid()===false){
                errores++;
            }
        }
        if(this.getField('ch_excel').getValue()==='false' && this.getField('ch_pdf').getValue()==='false'){
            errores++;
            this.getField('ch_excel').setError(true,'* Es necesario seleccionar una opción.');
            this.getField('ch_pdf').setError(true,'* Es necesario seleccionar una opción.');
            /* this.getField('ch_pantalla').setError(true,'* Es necesario seleccionar una opción.'); */
            this.operacion_actual='';
            this.alertGeneral.toggle(true, 'Es necesario seleccionar una opción: Pdf o Excel.', 'error');
        }
        
        if(errores===0){
            if(this.operacion_actual!==''){
                if(this.getField('radio_correo').getValue()==='S'){
                    this.enviarCorreoTerceros();
                }else{
                    this.nombre_pdf='compra';
                    this.nombre_excel='compra';
                    if(this.operacion_actual==='pdf'){
                        this.generarPdfTabla3();
                    }else if(this.operacion_actual==='pantalla'){
                        //nothing
                    }else if(this.operacion_actual==='excel'){
                        this.generarExcelTabla3();
                    } 
                }
            }else{
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } 
        }
    }


    enviarCorreoTerceros(){
      this.mostrarMensajeGenerando();
      let datos={ datos: {
        sucursal_ingreso:this.sucursal_ingreso,
        email:this.getField('email').getValue(),
        radio_correo:this.getField('radio_correo').getValue(),
        operacion:this.operacion_actual,
      }};

      this.columnSelected = localStorage.getItem('columnB');

      if(this.filterTextLoweCase !== "" && this.columnSelected !== ""){
        datos.datos.value=this.filterTextLoweCase;
        datos.datos.column = this.columnSelected
      }

      

      this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: 'imprimir_basicos_logisticos', operacion_tipo: 'consulta' };
      this.service.send(
      {
              endpoint: this.constant.formConfiguration(),
              method:'GET',
              body: datos,
              success: this.successEnviarCorreo,
              error: this.error_,
              general: this.generalFormatPmv,
              showMessage: false
      });
  }
  
  successEnviarCorreo(data){
      this.getField('confirmModalCustom').toggle(false);
      if(data.estado_p === 200){
          this.mostrarMensajeEmailEnviado();
      }else{
          this.mostrarMensajeEmailFallo();
          let respuesta=Object.values(data.data.errores);
          this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
      }
  }

  mostrarMensajeEmailEnviado(){
    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
    this.getField('confirmModalCustom').toggle(true);
  }

  mostrarMensajeEmailFallo(){
    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
    this.getField('confirmModalCustom').toggle(true);
  }

  mostrarMensajeNoHayDatos(){
    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
    this.getField('confirmModalCustom').toggle(true);
}

  generarPdfTabla3()
    {       
            this.mostrarMensajeGenerando();
            let url = this.constant.formConfiguration();
            let datos2= {
                sucursal_ingreso:this.sucursal_ingreso,
                operacion:this.operacion_actual,
                radio_correo:this.getField('radio_correo').getValue(),
            };
            
            this.columnSelected = localStorage.getItem('columnB');
            
            if(this.filterTextLoweCase !== "" && this.columnSelected !== ""){
                datos2.value=this.filterTextLoweCase;
                datos2.column = this.columnSelected
            }


            let op='imprimir_basicos_logisticos';

            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"serlog-activosfijosbasicoslog","operacion":"'+op+'","operacion_tipo":"consulta"}}';
            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
            return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const pdf = new File([blob], this.nombre_archivo+'.pdf', {
                                type:'application/pdf'});
                            window.open(URL.createObjectURL(pdf));
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
              this.alertGeneral.toggle(true,err,'error');
            });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    generarExcelTabla3()
    {
            this.mostrarMensajeGenerando();
            let url = this.constant.formConfiguration();
            let datos2= {
                sucursal_ingreso:this.sucursal_ingreso,
                operacion:this.operacion_actual,
                radio_correo:this.getField('radio_correo').getValue(),
            };
            let op='imprimir_basicos_logisticos';

            this.columnSelected = localStorage.getItem('columnB');

            if(this.filterTextLoweCase !== "" && this.columnSelected !== ""){
                datos2.value=this.filterTextLoweCase;
                datos2.column = this.columnSelected
            }


            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"serlog-activosfijosbasicoslog","operacion":"'+op+'","operacion_tipo":"consulta"}}';
            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
                return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            // the filename you want
                            a.download = this.nombre_archivo+'.xlsx';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            alert('Se descargo el archivo!');
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true,err,'error');
            });
    }


    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Compras', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


    sqlFilterTable(e){
        if(this.filter_numero_documento){
            if(this.filter_numero_aux !== ""){
                let regex = new RegExp("^[A-Za-z0-9-]+$");
    
                
                if (regex.test(this.filter_numero_aux)) {
                    this.filterTextLoweCase=this.filter_numero_aux;
                    this.columnSelected =  e.columns[0].colId.toString();
                    localStorage.setItem('columnB', e.columns[0].colId.toString());
    
                    let datos = this.returnObjectSendSqlFilterTable();
                    
    /*                     let datos = { datos: {
                        codigo_activo: this.filterTextLoweCase
                    }}; */
                    this.getField("rejilla").setTipoServicioOperacion('serlog-activosfijosbasicoslog-1_1');
                    this.getField("rejilla").sendRequest(this.successtraerTodos, datos); 
                }else{
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Filtro no cumple con el formatado deseado.');
                    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField('confirmModalCustom').toggle(true);
                }
            }/* else{
                this.limpiarVariables();
            } */
        }
    }

    returnObjectSendSqlFilterTable(){
        let datos = { datos: {}}; 
        if (this.columnSelected !== "") {
            switch (this.columnSelected) {
                case 'codigo':
                    datos.datos.codigo = this.filterTextLoweCase;
                    break;

                case 'serialactivo':
                    datos.datos.serialactivo = this.filterTextLoweCase;
                break;

                case 'nombre_serie':
                    datos.datos.nombre_serie = this.filterTextLoweCase;
                break;
                case 'nombre':
                    datos.datos.nombre = this.filterTextLoweCase;
                break;

                case 'codigobodega':
                    datos.datos.codigobodega = this.filterTextLoweCase;
                break;

                case 'descripcion_bodega':
                    datos.datos.descripcion_bodega = this.filterTextLoweCase;
                break; 
 
                case 'fechacreacion':
                    datos.datos.fechacreacion = this.filterTextLoweCase;
                break; 
                
                case 'nombre_grupo_serie':
                    datos.datos.nombre_grupo_serie = this.filterTextLoweCase;
                    break; 

                case 'nombre_grupo':
                    datos.datos.nombre_grupo = this.filterTextLoweCase;
                break;

                case 'codigo_grupo':
                    datos.datos.codigo_grupo = this.filterTextLoweCase;
                break;

                case 'codigo_grupo_serie':
                    datos.datos.codigo_grupo_serie = this.filterTextLoweCase;
                break;
                
                case 'estado_grupo':
                    datos.datos.estado_grupo = this.filterTextLoweCase;
                break;               

                default:
                    break;
                    
                ;
            }
        }
        return datos;
    }

    getValueFilterColumn(event){
        ///event.filterInstance.textFilterParams.column.colId === 'codigo_activo'
        /* if(event.filterInstance.textFilterParams !== undefined && (event.filterInstance.textFilterParams.column.colId === 'codigo' || event.filterInstance.textFilterParams.column.colId === 'serialactivo' || event.filterInstance.textFilterParams.column.colId === 'fechacreacion') ){ */
        if(event.filterInstance.textFilterParams !== undefined && this.validateColumnFilter(event) ){
/*             this.columnSelected = event.filterInstance.textFilterParams.column.colId;
            console.log('column selected ', this.columnSelected); */
            this.filter_numero_documento= true;
            if(event.filterInstance.eValue1 !== undefined && event.filterInstance.eValue1 !==''){
                this.filter_numero_aux = event.filterInstance.eValue1.value;
            }else if(event.filterInstance.eValueFrom1 !== undefined && event.filterInstance.eValueFrom1 !==''){
                this.filter_numero_aux = event.filterInstance.eValueFrom1.eInput.value;
            }else{
                if(event.filterInstance.eConditionBodies[0].children[0].children[1].children[0].value !== undefined && event.filterInstance.eConditionBodies[0].children[0].children[1].children[0].value !=='')
                    this.filter_numero_aux = event.filterInstance.eConditionBodies[0].children[0].children[1].children[0].value;
            }
            

        }else{
            this.filter_numero_documento= false;
            /* this.limpiarVariables(); */
        }
        
    }

    validateColumnFilter(event){
        let nameColumn = event.filterInstance.textFilterParams.column.colId;
        let column = false;
        switch (nameColumn) {
            case 'codigo':
            case 'serialactivo':
            case 'nombre_serie':
            case 'nombre':
            case 'codigobodega':
            case 'descripcion_bodega':
            case 'fechacreacion':
            case 'nombre_grupo_serie':
            case 'nombre_grupo':
            case 'codigo_grupo':
            case 'codigo_grupo_serie':
            case 'estado_grupo':
            case 'numero':
                column = true;
                this.columnSelected = nameColumn;
                break;
            default:
                column = false;
                this.columnSelected = '';
                break;
        }

        return column;
    
    }

}
FormJaivana.addController("serlog-activosfijosbasicoslog", CustomActivosFijosBasicosLogisticos);
export default CustomActivosFijosBasicosLogisticos